import React from "react"

import { CTAButton, CustomCTATeaser } from "./style"

const CustomCTA = ({ attribs }) => {
  const fluid = {
    sourceUrl: attribs.sourceurl,
    srcSet: attribs.srcset,
    sizes: "100vw",
    aspectRatio: 1,
  }

  return (
    <CustomCTATeaser
      img={fluid || null}
      title={attribs.heading}
      link={attribs.link}
      excerpt={attribs.message}
    >
      <CTAButton to={attribs.link}>{attribs.linktext}</CTAButton>
    </CustomCTATeaser>
  )
}

export default CustomCTA
